const BASE_URL = 'https://maps';
const DEFAULT_URL = `${BASE_URL}.googleapis.com`;
//googleMapsapiLoadedPromise is a custom callback which will run once the google map object is loaded
const API_PATH = '/maps/api/js?callback=googleMapsapiLoadedPromise';
const EVENT_GMAPS_LOADED = 'EVENT_GMAPS_LOADED';

const getBaseUrl = region => {
  // incase the language is chinese, it has to be routed to google.cn
  if (region && region.toLowerCase() === 'cn') {
    return `${BASE_URL}.google.cn`;
  }
  return DEFAULT_URL;
};

let promiseResolver = null;
let lastBaseUrl = '';
let lastScriptUrl = '';
let googleMapsPromise;

const destroyOldGoogleMapsInstance = url => {
  document
    .querySelectorAll(`script[src^="${url}"]`)
    .forEach(script => script.remove());
  // google map react library create a global window object
  if (window.google) {
    Reflect.deleteProperty(window.google, 'maps');
  }
};

//https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
window.googleMapsapiLoadedPromise = () =>
  window.dispatchEvent(new CustomEvent(EVENT_GMAPS_LOADED));

const getScriptUrl = bootstrapURLKeys => {
  const baseUrl = getBaseUrl(bootstrapURLKeys.region);
  const params = Object.keys(bootstrapURLKeys).reduce(
    (r, key) => `${r}&${key}=${bootstrapURLKeys[key]}`,
    '',
  );
  const completeUrl = `${baseUrl}${API_PATH}${params}`;
  return completeUrl;
};

// Google map react library creates dynamic script for fetching the data on the first render
// we can replace the script with the custom url with prefered language and region
//Source -> https://developers.google.com/maps/documentation/javascript/overview#Dynamic
const loadScript = url => {
  const script = document.createElement('script');

  script.type = 'text/javascript';
  script.async = true;
  script.src = url;
  document.querySelector('head').appendChild(script);

  return new Promise(resolve => {
    if (promiseResolver) {
      window.removeEventListener(EVENT_GMAPS_LOADED, promiseResolver);
    }
    promiseResolver = () => {
      resolve();
    };
    window.addEventListener(EVENT_GMAPS_LOADED, promiseResolver);
  });
};

const loadGoogleMaps = bootstrapURLKeys =>
  new Promise(resolve => {
    lastScriptUrl = getScriptUrl(bootstrapURLKeys);
    loadScript(lastScriptUrl).then(() => {
      resolve(window.google.maps);
    });
  });

export const googleMaploader = bootstrapURLKeys => {
  if (typeof window === 'undefined') {
    throw new Error('cannot load google maps');
  }
  if (googleMapsPromise) {
    if (lastScriptUrl !== getScriptUrl(bootstrapURLKeys)) {
      destroyOldGoogleMapsInstance(lastBaseUrl);
      googleMapsPromise = loadGoogleMaps(bootstrapURLKeys);
    }
    return googleMapsPromise;
  }

  googleMapsPromise = loadGoogleMaps(bootstrapURLKeys);
  lastBaseUrl = getBaseUrl(bootstrapURLKeys.region);
  return googleMapsPromise;
};
